import { jsx } from "react/jsx-runtime";
import { Root } from "./Root.js";
import { useStyles } from "./useStyles.js";
function FormFooter(props) {
  const { children, testId = "form-footer-root", ...rest } = props;
  const sx = useStyles(rest);
  return /* @__PURE__ */ jsx(Root, { sx, "data-testid": testId, children });
}
export {
  FormFooter
};
//# sourceMappingURL=FormFooter.js.map
